var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../element-factory";
import { SurveyLocStringViewer } from "../string-viewer";
var QuestionErrorComponent = /** @class */ (function (_super) {
    __extends(QuestionErrorComponent, _super);
    function QuestionErrorComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionErrorComponent.prototype.render = function () {
        var error = this.props.error;
        var classes = this.props.cssClasses;
        return (React.createElement("div", null,
            React.createElement("span", { className: error.getCssIcon(classes), "aria-hidden": "true" }),
            React.createElement("span", { className: this.props.cssClasses.error.item || undefined },
                React.createElement(SurveyLocStringViewer, { locStr: error.locText }))));
    };
    return QuestionErrorComponent;
}(React.Component));
export { QuestionErrorComponent };
ReactElementFactory.Instance.registerElement("sv-question-error", function (props) {
    return React.createElement(QuestionErrorComponent, props);
});
